module.exports = __webpack_public_path__ + "img/flash.6ddef1cd.png";